import {
    MainScreen,
    FinalTerminationScreen,
    ErrorScreen
} from '../components/screens';

import {
    TermsAndConditionScreenEnglish,
    TermsDeclineScreenEnglish
} from '../components/screens/terms-screens'

import {
  TermsAndConditionScreenFrench,
  TermsDeclineScreenFrench
} from '../components/screens/terms-screens'

import {
  TermsAndConditionScreenSpanish,
  TermsDeclineScreenSpanish
} from '../components/screens/terms-screens'

const EnglishIntroductionRoutes = [{
    path: '/TermsAndConditions',
    component: TermsAndConditionScreenEnglish,
    requireSessionID: true,
    monitorProgress: false
  },
  {
    path: '/DeclineTermsAndConditions',
    component: TermsDeclineScreenEnglish,
    requireSessionID: true,
    monitorProgress: false
  }
]

const FrenchIntroductionRoutes = [{
  path: '/TermsAndConditions',
  component: TermsAndConditionScreenFrench,
  requireSessionID: true,
  monitorProgress: false
},
{
  path: '/DeclineTermsAndConditions',
  component: TermsDeclineScreenFrench,
  requireSessionID: true,
  monitorProgress: false
}
]

const SpanishIntroductionRoutes = [{
  path: '/TermsAndConditions',
  component: TermsAndConditionScreenSpanish,
  requireSessionID: true,
  monitorProgress: false
},
{
  path: '/DeclineTermsAndConditions',
  component: TermsDeclineScreenSpanish,
  requireSessionID: true,
  monitorProgress: false
}
]

const GlobalIntroductionRoutes = [{
    path: '/',
    component: MainScreen,
    monitorProgress: false
  },
  {
    path:'/Error',
    component: ErrorScreen,
    monitorProgress: false
  }
]

export const getIntroductionRoutes = (versionId) => {
    switch (parseInt(versionId)) {
      case 36:
      case 39:
      case 40:
      case 41:
      case 42:
      case 43:
      case 37:
      case 56:
      case 57:
      case 58:
      case 59:
      case 60:
      case 38:
      case 67:
      case 68:
      case 69:
      case 70:
      case 71:
        return [...EnglishIntroductionRoutes, ...GlobalIntroductionRoutes];
      case 44:
      case 45:
      case 46:
      case 47:
      case 48:
      case 49:
      case 61:
      case 62:
      case 63:
      case 64:
      case 65:
      case 66:
      case 72:
      case 73:
      case 74:
      case 75:
      case 76:
      case 77:
        return [...FrenchIntroductionRoutes, ...GlobalIntroductionRoutes];
      case 50:
      case 51:
      case 52:
      case 53:
      case 54:
      case 55:
      case 78:
      case 79:
      case 80:
      case 81:
      case 82:
      case 83:
        return [...SpanishIntroductionRoutes, ...GlobalIntroductionRoutes];
      default:
        return null;
    }
  }

// export const IntroductionRoutes = [
//     { path: '/', component: MainScreen, requireSessionID: false, monitorProgress: false },
//     { path: '/TermsAndConditions', component: TermsAndConditionScreen, requireSessionID: true, monitorProgress: true },
//     { path: '/DeclineTermsAndConditions', component: TermsDeclineScreen, requireSessionID: true, monitorProgress: false },
//     { path: '/FinalTermination', component: FinalTerminationScreen, requireSessionID: false, monitorProgress: false },
// ]